import * as React from 'react'
import type { DividerProps } from 'types/content-editor'

const DividerBlock = ({
  borderWidth,
  borderColor,
  borderStyle,
  padding,
}: DividerProps): React.ReactElement<'div'> => (
  <div
    className="content-editor__divider-block"
    style={{
      borderTop: `${borderWidth} ${borderStyle} ${borderColor}`,
      margin: padding,
    }}
  />
)

export default DividerBlock
